export default "__VITE_ASSET__zDlQhijQ__"